import * as Popover from '@radix-ui/react-popover';
import type { AutomationCategoryResponse } from '@reach/shared-types/automation-category';
import { ChevronDown, Tag } from 'lucide-react';
import { CategoryPill } from '../../feature-setup/automation-categories/CategoryPill/CategoryPill';
import styles from './EngageLibraryCategoryFilter.module.css';

interface EngageLibraryCategoryFilterProps {
  categories: AutomationCategoryResponse[];
  selectedCategoryIds: string[];
  onChange: (categoryIds: string[]) => void;
}

export function EngageLibraryCategoryFilter({
  categories,
  selectedCategoryIds,
  onChange,
}: EngageLibraryCategoryFilterProps) {
  const selectedCount = selectedCategoryIds.length;
  const hasSelection = selectedCount > 0;

  const toggleCategory = (categoryId: string) => {
    const isSelected = selectedCategoryIds.includes(categoryId);
    onChange(
      isSelected
        ? selectedCategoryIds.filter(selectedId => selectedId !== categoryId)
        : [...selectedCategoryIds, categoryId],
    );
  };

  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <button type="button" className={styles.filterButton} data-active={hasSelection}>
          <Tag className={styles.filterIcon} aria-hidden />
          Category
          {hasSelection && <span className={styles.countPill}>{selectedCount}</span>}
          <ChevronDown className={styles.caret} aria-hidden />
        </button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content className={styles.menu} align="start" sideOffset={8}>
          <fieldset className={styles.options}>
            <legend>Filter by category</legend>
            {categories.map(category => (
              <label key={category.id}>
                <input
                  type="checkbox"
                  checked={selectedCategoryIds.includes(category.id)}
                  onChange={() => toggleCategory(category.id)}
                />
                <CategoryPill category={category} />
              </label>
            ))}
          </fieldset>
          {hasSelection && (
            <footer className={styles.footer}>
              <span>{selectedCount} selected</span>
              <button type="button" onClick={() => onChange([])}>
                Clear
              </button>
            </footer>
          )}
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
